export default "__VITE_ASSET__DgvQh_s6__"